import { useEffect, useRef, useState } from 'react';
import { getMatchShowResult } from 'service/base';

const mockMatches = [
  {
    title: 'Man United - Man City (13/08/2025, 03:00)',
    homeTeam: {
      name: 'Man United',
      logo: 'https://upload.wikimedia.org/wikipedia/en/7/7a/Manchester_United_FC_crest.svg',
      score: 2
    },
    awayTeam: {
      name: 'Man City',
      logo: 'https://upload.wikimedia.org/wikipedia/en/e/eb/Manchester_City_FC_badge.svg',
      score: 1
    },
    results: [
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 }
    ]
  },
  {
    title: 'Man United - Man City (13/08/2025, 03:00)',
    homeTeam: {
      name: 'Man United',
      logo: 'https://upload.wikimedia.org/wikipedia/en/7/7a/Manchester_United_FC_crest.svg',
      score: 2
    },
    awayTeam: {
      name: 'Man City',
      logo: 'https://upload.wikimedia.org/wikipedia/en/e/eb/Manchester_City_FC_badge.svg',
      score: 1
    },
    results: [
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 },
      { account: 'tr****1', name: 'NGUY****OAFFv', vipLevel: 3, point: 99 }
    ]
  }
];

const MatchResult = ({ match }) => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const scrollRef = useRef(null);
  const rowHeight = 40; // Adjust based on actual row height
  const visibleRows = 7;

  useEffect(() => {
    const interval = setInterval(() => {
      setScrollIndex((prevIndex) => {
        const maxIndex = Math.max(0, match.results.length - 1);
        return (prevIndex + 1) % (maxIndex + 1);
      });
    }, 2000); // Change scroll every 3 seconds

    return () => clearInterval(interval);
  }, [match.results.length]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollIndex * rowHeight; // Adjust 40 based on row height
    }
  }, [scrollIndex]);

  return (
    <div className="rounded-[12px] overflow-hidden mb-3 border border-[#d8dbe0] bg-[#eceff3]">
      <div className="bg-[#f27121] text-white px-3 py-1 text-[14px] leading-5 font-bold w-fit rounded-br-[20px]">
        {match.title}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] gap-2 px-2">
        <div className="rounded-[10px] bg-[#eceff3] lg:px-2.5 lg:py-2 flex flex-col lg:min-h-[205px]">
          <div className="mt-1">
            <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full border border-[#d7dce3] bg-white overflow-hidden flex items-center justify-center">
                  <img
                    src={match.homeTeam.logo}
                    alt={match.homeTeam.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="mt-1.5 block w-full text-[14px] leading-4 font-bold text-[#ea6418] text-center">
                  {match.homeTeam.name}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-[7px] bg-[#ea6418] text-white font-black text-[18px] leading-7 text-center">
                  {match.homeTeam.score}
                </span>
                <span className="text-[20px] md:text-[30px] font-black leading-none text-[#111827]">:</span>
                <span className="w-8 h-8 rounded-[7px] bg-[#ea6418] text-white font-black text-[18px] leading-7 text-center">
                  {match.awayTeam.score}
                </span>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full border border-[#d7dce3] bg-white overflow-hidden flex items-center justify-center">
                  <img
                    src={match.awayTeam.logo}
                    alt={match.awayTeam.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="mt-1.5 block w-full text-[14px] leading-4 font-bold text-[#ea6418] text-center">
                  {match.awayTeam.name}
                </span>
              </div>
            </div>
          </div>

          <div className="w-full h-px bg-[#d7dce3] mt-2 mb-1.5" />
          <div className="pt-1 md:flex-1 md:flex md:items-center">
            <div className="w-full flex items-center justify-between gap-3">
              <p className="text-[#2f3845] text-[14px] md:text-[17px] font-bold">Số người dự đoán đúng</p>
              <p className="text-[#ea6418] text-[14px] md:text-[46px] leading-[36px] md:leading-[48px] font-black">
                {match.results.length}
              </p>
            </div>
          </div>
        </div>

        <div
          className="overflow-y-auto rounded-[8px] border border-[#d5dae1] bg-[#f5f6f8]"
          ref={scrollRef}
          style={{ maxHeight: `${rowHeight * 4 + 34}px` }}
        >
          <table className="table-fixed w-full text-[12px]">
            <thead className="sticky top-0 z-10">
              <tr className="bg-[#f27121] text-white">
                <th className="py-1.5 px-2 w-[12%] text-center font-bold">STT</th>
                <th className="py-1.5 px-2 w-[18%] text-center font-bold">TK</th>
                <th className="py-1.5 px-2 w-[38%] text-center font-bold">Họ và Tên</th>
                <th className="py-1.5 px-2 w-[12%] text-center font-bold">VIP</th>
                <th className="py-1.5 px-2 w-[20%] text-center font-bold">ĐIỂM THƯỞNG</th>
              </tr>
            </thead>
            <tbody>
              {match.results.map((result, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-[#f4e8de]'}>
                  <td className="py-2 px-2 text-center text-[#1f2937]">{index + 1}</td>
                  <td className="py-2 px-2 text-center text-[#1f2937]">{result.account}</td>
                  <td className="py-2 px-2 text-center text-[#1f2937] truncate">{result.name}</td>
                  <td className="py-2 px-2 text-center text-[#1f2937]">{result.vipLevel}</td>
                  <td className="py-2 px-2 text-center text-[#1f2937]">{result.point}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const MatchResultsList = ({ embedded = false }) => {
  const [matches, setMatches] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getMatchShowResult();
        console.log('API response:', response);
        if (response.code === 0 && Array.isArray(response.data) && response.data.length > 0) {
          setMatches(response.data.filter((item) => item?.results?.length > 0));
          setError(null);
        } else {
          setMatches(mockMatches);
          setError(null);
        }
      } catch (err) {
        setMatches(mockMatches);
        setError(null);
        console.error('Fetch error:', err);
      }
    };
    fetchData();
  }, []);

  return (
    <div
      className={
        embedded
          ? 'w-full pb-2'
          : 'xl:w-7/10 md:w-9/10 sm:w-9/10 w-9/10 max-w-[1000px] mx-auto bg-gray-100 pb-10 bg-white/95 border-2 border-solid shadow shadow-primary p-2 w-full md:pb-8 md:pt-4 rounded-2xl'
      }
      style={
        embedded
          ? undefined
          : {
              background: '#FFFFFF80',
              borderColor: '#f27121',
              borderRadius: '1.5rem'
            }
      }
    >
      {!embedded ? (
        <h2 className="text-2xl font-bold text-center rounded-t-xl text-white bg-[#f27121] mb-8 py-2 ">
          KẾT QUẢ TRẬN ĐẤU
        </h2>
      ) : null}
      {error && <div className="text-red-500 text-center mb-4">{error}</div>}
      <div className="mx-auto flex flex-col gap-2">
        {matches.map((match, index) => (
          <MatchResult key={index} match={match} />
        ))}
      </div>
    </div>
  );
};

export default MatchResultsList;
